import { render, staticRenderFns } from "./JoinUs.vue?vue&type=template&id=9f88cd4c&scoped=true"
import script from "./JoinUs.vue?vue&type=script&lang=js"
export * from "./JoinUs.vue?vue&type=script&lang=js"
import style0 from "./JoinUs.vue?vue&type=style&index=0&id=9f88cd4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f88cd4c",
  null
  
)

export default component.exports